

import { useState } from "react"

const Services = () => {
  const [hoveredCard, setHoveredCard] = useState(null)

  const services = [
    {
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
      ),
      title: "Search Engine Optimization (SEO)",
      description: "Rank higher on search engines, attract quality traffic, and grow your business organically.",
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      bgColor: "rgba(102, 126, 234, 0.1)",
    },
    {
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7 10v12" />
          <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h3.5a2 2 0 0 1 2 2.5" />
        </svg>
      ),
      title: "Social Media Marketing",
      description:
        "Build your brand presence and engage with your audience on platforms like Facebook, Instagram, and LinkedIn.",
      color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      bgColor: "rgba(240, 147, 251, 0.1)",
    },
    {
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
          <circle cx="12" cy="5" r="2" />
          <path d="m12 7-2 4h4l-2-4Z" />
        </svg>
      ),
      title: "Pay-Per-Click Advertising (PPC)",
      description: "Run high-converting ads on Google and social media to generate instant leads and sales.",
      color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      bgColor: "rgba(79, 172, 254, 0.1)",
    },
    {
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14,2 14,8 20,8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10,9 9,9 8,9" />
        </svg>
      ),
      title: "Content Marketing",
      description: "Educate, entertain, and inspire your audience with blogs, videos, infographics, and more.",
      color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      bgColor: "rgba(250, 112, 154, 0.1)",
    },
    {
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      ),
      title: "Email Marketing",
      description: "Turn your subscribers into loyal customers with personalized and automated email campaigns.",
      color: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      bgColor: "rgba(168, 237, 234, 0.1)",
    },
    {
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="16 18 22 12 16 6" />
          <polyline points="8 6 2 12 8 18" />
        </svg>
      ),
      title: "Website Design & Development",
      description: "Get a modern, responsive, and conversion-focused website that reflects your brand perfectly.",
      color: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
      bgColor: "rgba(255, 236, 210, 0.1)",
    },
  ]

  return (
    <section
      className="py-5"
      style={{
        minHeight: "60vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Animated Background Elements */}
      <div
        style={{
          position: "absolute",
          top: "10%",
          left: "5%",
          width: "300px",
          height: "300px",
          background: "rgba(255, 255, 255, 0.1)",
          borderRadius: "50%",
          filter: "blur(40px)",
          animation: "float1 6s ease-in-out infinite",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          bottom: "10%",
          right: "5%",
          width: "200px",
          height: "200px",
          background: "rgba(255, 255, 255, 0.08)",
          borderRadius: "50%",
          filter: "blur(30px)",
          animation: "float2 8s ease-in-out infinite reverse",
        }}
      ></div>

      <div className="container">
        {/* Section Header */}
        <div className="row justify-content-center mb-3">
          <div className="col-lg-8 text-center">
            <h4
              className="display-4 fw-bold mb-4 text-black"
              style={{
                //textShadow: "0 4px 20px rgba(0,0,0,0.3)",
                letterSpacing: "-1px",
                fontSize: "50px",
              }}
            >
              Our Digital Marketing Services
            </h4>
            <p
              className="lead text-black mb-0"
              style={{
                maxWidth: "400px",
                margin: "0 auto",
                fontSize: "1.5rem",
                color: "rgba(0,0,0,0.7)",
              }}
            >
              Innovative digital solutions designed to elevate your brand and drive exceptional results
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row g-4">
          {services.map((service, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div
                className="h-100 position-relative"
                style={{
                  transform: hoveredCard === index ? "translateY(-20px) scale(1.02)" : "translateY(0) scale(1)",
                  transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  cursor: "pointer",
                }}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                {/* Glassmorphism Card */}
                <div
                  style={{
                    background: "rgba(255, 255, 255, 0.15)",
                    backdropFilter: "blur(20px)",
                    borderRadius: "24px",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    padding: "1.5rem 1.5rem",
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow:
                      hoveredCard === index ? "0 25px 50px rgba(0, 0, 0, 0.25)" : "0 8px 32px rgba(0, 0, 0, 0.12)",
                  }}
                >
                  {/* Gradient Overlay */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: hoveredCard === index ? service.bgColor : "transparent",
                      borderRadius: "24px",
                      transition: "all 0.4s ease",
                      opacity: hoveredCard === index ? 1 : 0,
                    }}
                  ></div>

                  {/* Content */}
                  <div className="position-relative">
                    {/* Floating Icon Container */}
                    <div className="text-center mb-4">
                      <div
                        className="d-inline-flex align-items-center justify-content-center position-relative"
                        style={{
                          width: "70px",
                          height: "70px",
                          background: service.color,
                          borderRadius: "50%",
                          color: "white",
                          boxShadow: "0 15px 35px rgba(0, 0, 0, 0.2)",
                          transform: hoveredCard === index ? "rotate(360deg) scale(1.1)" : "rotate(0deg) scale(1)",
                          transition: "all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                        }}
                      >
                        {/* Icon Glow Effect */}
                        <div
                          style={{
                            position: "absolute",
                            top: "-10px",
                            left: "-10px",
                            right: "-10px",
                            bottom: "-10px",
                            background: service.color,
                            borderRadius: "50%",
                            opacity: hoveredCard === index ? 0.3 : 0,
                            filter: "blur(20px)",
                            transition: "opacity 0.4s ease",
                          }}
                        ></div>

                        {service.icon}
                      </div>
                    </div>

                    {/* Service Title */}
                    <h5
                      className="text-black fw-bold mb-3 text-center"
                      style={{
                        fontSize: "2rem",
                        lineHeight: "1",
                        //textShadow: "0 2px 10px rgba(0,0,0,0.3)",
                      }}
                    >
                      {service.title}
                    </h5>

                    {/* Service Description */}
                    <p
                      className="text-black text-center mb-4"
                      style={{
                        lineHeight: "1",
                        fontSize: "1.2rem",
                        color: "rgba(0,0,0,0.7)",
                      }}
                    >
                      {service.description}
                    </p>
                  </div>

                  {/* Decorative Elements */}
                  <div
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                      width: "60px",
                      height: "60px",
                      background: "rgba(255, 255, 255, 0.1)",
                      borderRadius: "50%",
                      opacity: hoveredCard === index ? 1 : 0,
                      transition: "opacity 0.4s ease",
                      filter: "blur(10px)",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
